import { Component, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { Category } from '../../../models/category/category.model';
import { CategoryService } from '../../../services/category/category.service';
import { UtilitiesService } from '../../../services/shared/utilities.service';

@Component({
    selector: 'app-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.css']
})
/** category-list component*/
export class CategoryListComponent {
  public categoryList: Category[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
    /** category-list ctor */
  constructor(private readonly categoryService: CategoryService, private readonly utilitiesService: UtilitiesService) {
    this.GetCategoryList();
    this.GetRowsPerPageList();
    }

  GetCategoryList() {
    this.categoryService.GetCategoryListUnderParent().subscribe(
      data => {
        this.categoryList = data;
        this.filteredItems = data;
      }
    )
  }

  deleteCategory(id) {
    var ans = confirm("Are you sure to delete with Id: " + id);
    if (ans) {
      this.categoryService.DeleteCategory(id);
      setTimeout(() => {
        this.GetCategoryList();
      }, 2000);
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.categoryList, searchText);

    } else {
      this.filteredItems = this.categoryList;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/category-components/category/category-list/category-list.component.ts